import { Config } from '../../config'

export const gmiConfig: Config = {
  partner: 'gmi',
  catalog: 'partner',
  displayName: 'GMI',
  accentColor: '#2568b3',
  host: 'seating.gmi-inc.com',
}

